<template>
  <section id="terms-and-conditions" class="container section">
    <div class="columns is-centered">
      <div class="column is-half-fullhd">
        <h1 class="title">{{ $t("terms.title") }}</h1>
        <ol>
          <li v-for="(item, index) in content" :key="index">
            <p v-html="item.text" />
          </li>
        </ol>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
const { locale, messages } = useI18n();
const content = computed(() => {
  const currentLocale = locale.value;
  const localeMessages = messages.value?.[currentLocale];
  return localeMessages?.terms?.content || [];
});
</script>

<style scoped lang="scss">
#terms-and-conditions {
  h1 {
    font-size: 2em;
    margin-bottom: 1em;
  }
  li {
    margin-bottom: 1rem;
  }

  .title {
    color: var(--font-color);
  }
}
</style>
